import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ textAlign: 'center', padding: '60px' }}>Chargement...</div>;
  }

  if (!user) {
    return <Navigate to="/connexion" replace />;
  }

  return children;
};

export default ProtectedRoute;